export default __webpack_public_path__ + "static/media/Profesional.a901c685.jpg";